import { enqueueSnackbar } from 'notistack'
import i18next from 'Services/localize/i18n'
const cfdToast = {
    success: (message: string, additionValue?: any, duration?: number) => {
        const successMessage = i18next.t(message, additionValue)
        enqueueSnackbar(
            <span dangerouslySetInnerHTML={{ __html: successMessage }} />,
            {
                variant: 'success',
                autoHideDuration: duration || 3000,
            },
        )
    },
    error: (message: string, additionValue?: any, duration?: number) => {
        const errorMessage = i18next.t(message, additionValue)
        enqueueSnackbar(
            <span dangerouslySetInnerHTML={{ __html: errorMessage }} />,
            {
                variant: 'error',
                autoHideDuration: duration || 3000,
            },
        )
    },
    info: (message: string, additionValue?: any, duration?: number) => {
        const infoMessage = i18next.t(message, additionValue)
        enqueueSnackbar(
            <span dangerouslySetInnerHTML={{ __html: infoMessage }} />,
            {
                variant: 'info',
                autoHideDuration: duration || 5000,
            },
        )
    },
    warning: (message: string, additionValue?: any, duration?: number) => {
        const warningMessage = i18next.t(message, additionValue)
        enqueueSnackbar(
            <span dangerouslySetInnerHTML={{ __html: warningMessage }} />,
            {
                variant: 'warning',
                autoHideDuration: duration || 3000,
            },
        )
    },
}

export default cfdToast
